import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const GetDriver = createAsyncThunk('appBookingValidation/GetDriverList', async (GetDriver) => {
  const response = await axios.post(' https://api.zasway.com:8443/Driver/GetDriverList', GetDriver, {mode:'cors'})
  return response.data
})

export const getPassengerList = createAsyncThunk('appBookingValidation/getPassengerList', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/Common/GetPassengerList', params, {mode: 'cors'})
  return response.data
})
export const getPaymentMethodList = createAsyncThunk('appBookingValidation/getPaymentMethodList', async (params) => {
  const companyID = JSON.parse(localStorage.getItem('companyID')) || 0
  const response = await axios.post(' https://api.zasway.com:8443/Common/GetPaymentMethodList', params || { companyID })
  return response.data
})
export const getBookingStatusList = createAsyncThunk('appBookingValidation/GetBookingStatusesList', async () => {
  const response = await axios.post(' https://api.zasway.com:8443/Common/GetDispatchBookingStatusAllList')
  return response.data
})
export const getVehicleType = createAsyncThunk('appBookingValidation/getVehicleType', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/Common/GetVehicleTypeList', params, { mode: 'cors' })
  return response.data
})
export const getClientList = createAsyncThunk('appBookingValidation/getClientList', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/Common/GetClientList', params, {mode: 'cors'})
  return response.data
})

export const getUserType = createAsyncThunk('usertype/getUserType', async () => {

  const response = await axios.post(' https://api.zasway.com:8443/Common/GetUserTypeList')
  
    return response.data
})
export const GetBookingsIDForLostItems = createAsyncThunk('LostandFound/GetBookingsIDForLostItems', async (data) => {
  const response = await axios.post(' https://api.zasway.com:8443/LostandFound/GetBookingsIDForLostItems', data, {mode:'cors'})
  return response.data
})

export const GetDataForLostItems = createAsyncThunk('LostandFound/GetTableSummary', async (data) => {
   
  const response = await axios.post(' https://api.zasway.com:8443/LostandFound/GetTableSummary', data, {mode:'cors'})
  return response.data.allData
})

export const GetEditDataForLostItems = createAsyncThunk('LostandFound/GetEditDataForLostItems', async (data) => {
   
  const response = await axios.post(' https://api.zasway.com:8443/LostandFound/GetTableSummary', data, {mode:'cors'})
    
  return response.data.allData
})

export const GetBookingsListSearch = createAsyncThunk('LostandFound/GetBookingsIDForLostItems', async (data) => {
    
  const response = await axios.post(' https://api.zasway.com:8443/LostandFound/GetBookingsIDForLostItems', data, {mode:'cors'})
  return response.data
})

export const getCategoryType = createAsyncThunk('LostandFound/GetBookingsIDForLostItems', async () => {
  
  const response = await axios.post(' https://api.zasway.com:8443/LostandFound/GetLostItemCategoryList')
  
    return response.data
})

export const addLostItemsNotes = createAsyncThunk('LostandFound/Create',  async (data) => {
       
  const response = await axios.post(' https://api.zasway.com:8443/LostandFound/Create', data, {mode:'cors'})
   
return response
})


export const BookingSlice = createSlice({
  name: 'client',
  initialState: {
    data: []


  },
  reducers: {}
//   extraReducers: builder => {
//     builder
//     //   .addCase(getAllData.fulfilled, (state, action) => {
//     //     state.allData = action.payload
//     //   })
//   }
})

export default BookingSlice.reducer
